import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useRouter } from 'next/router'
import DayPicker from './DayPicker'
import MonthPicker from './MonthPicker'

const DatePickers = () => {
  const router = useRouter()
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {router.asPath === '/reports/' ? (
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <MonthPicker />
        </Box>
      ) : (
        <Box sx={{ display: { xs: 'none', md: 'flex', alignItems: 'center' } }}>
          <DayPicker start />
          <Typography variant="h6" sx={{ mx: 2 }}>
            To
          </Typography>
          <DayPicker />
        </Box>
      )}
    </LocalizationProvider>
  )
}

export default DatePickers
